export default __webpack_public_path__ + "static/media/arrow-select.9e8bc885.svg";